import { useState } from 'react';
import { WidgetProps } from '@rjsf/core';
import UnitSelector from '../BaseComponents/UnitSelector';
import CustomCheckbox from './CustomCheckbox';

const WidthModelProperties = (props: WidgetProps) => {
    const { schema, value, onChange } = props;
    const [checked, setChecked] = useState<boolean>(!!value);

    const handleCheckboxChange = (e: any) => {
        setChecked(e);
        !e && onChange('');
    };

    return (
        <div className="box-model">
            <CustomCheckbox {...props} schema={schema} onChange={handleCheckboxChange} />
            {checked && (
                <div className="inches-input">
                    <UnitSelector
                        value={value}
                        defaultValue={schema.default as string}
                        onChange={onChange}
                    />
                </div>
            )}
        </div>
    );
};

export default WidthModelProperties;
